export const customizingSubjectOfEmail = 'For customizing subject of email you can use next patterns:';
export const customizingAttachmentNameOfEmail = 'For customizing attachment name of email you can use next patterns:';
export const serviceUnavailable = 'Service unavailable. Try to reload a page.';
export const managedAtCompanyLevel = ' (Managed at Company Level)';
